import { DebugApiToken } from './components/debug-api-token.component';
import { DebugButton } from './components/debug-button.component';
import { DebugFormComponents } from './components/debug-form-components.component';
import { DebugI18n } from './components/debug-i18n.component';

export function DebugRoute() {

  const triggerError = () => {
    throw new Error('Test exception for Sentry');
  }

  return (
    <div className="pt-16 text-white pb-8">
      <div className="px-4">
        <div className="font-bold text-xl mt-1.5 mb-6">Debug</div>
      </div>
      <div className="px-4 space-y-16">
        <div>
          <div className="font-bold text-2xl mb-4">API</div>
          <div className="px-8">
            <DebugApiToken />
          </div>
        </div>

        <div>
          <div className="font-bold text-2xl mb-4">I18n</div>
          <div className="px-8">
            <DebugI18n />
          </div>
        </div>

        <div>
          <div className="font-bold text-2xl mb-4">Form Components</div>
          <div className="px-8">
            <DebugFormComponents />
          </div>
        </div>

        <div>
          <div className="font-bold text-2xl mb-4">Bugtracker</div>
          <div className="px-8">
            <DebugButton onClick={() => triggerError()}>Trigger Error</DebugButton>
          </div>
        </div>
      </div>
    </div>
  )
}
